import { useQueryClient } from 'react-query';

export default function useRefetch() {
  const queryClient = useQueryClient();
  async function refetchList(key) {
    queryClient.invalidateQueries(key);
  }
  return { refetchList };
}
